import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Alert } from '@bingads-webui-react/alert';

export const DuplicateWordAlert = () => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={i18n.getString(_TL_('You\'ve entered a duplicate search theme. Please rename the search theme and try again.'))}
      level="Warning"
      icon={(<div className="alert-image" />)}
      dismissible
    />
  );
};

export const TooLongWordAlert = () => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={i18n.getString(_TL_('The search theme you entered is too long (max. 80 characters).'))}
      level="Warning"
      icon={(<div className="alert-image" />)}
      dismissible
    />
  );
};

export const MaxSelectionAlert = ({ selectedOptionsLimit }) => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={i18n.getString(_TL_('You have reached the maximum amount of {{selectedOptionsLimit}} search themes. Please delete one to add more.'), { selectedOptionsLimit })}
      level="Warning"
      icon={(<div className="alert-image" />)}
      dismissible
    />

  );
};

MaxSelectionAlert.propTypes = {
  selectedOptionsLimit: PropTypes.number.isRequired,
};
